import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconShortForm = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <path
        d="M14 2.0001H6C5.46957 2.0001 4.96086 2.21082 4.58579 2.58589C4.21071 2.96096 4 3.46967 4 4.0001V20.0001C4 20.5305 4.21071 21.0392 4.58579 21.4143C4.96086 21.7894 5.46957 22.0001 6 22.0001H18C18.5304 22.0001 19.0391 21.7894 19.4142 21.4143C19.7893 21.0392 20 20.5305 20 20.0001V8.0001V4.00003C20 2.89545 19.1045 2.00002 18 2.00003L14 2.0001Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 6H12H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconShortForm.displayName = 'IconShortForm';
